/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ConnectorStatusByDnspResponse,
    DeviceStatusByDnspResponse,
    DnspControlIntervalsByDeviceResponse,
    DnspDeviceOptOutStatusResponse,
    DnspGetDerEventResponse,
} from "../models/index";
import {
    ConnectorStatusByDnspResponseFromJSON,
    ConnectorStatusByDnspResponseToJSON,
    DeviceStatusByDnspResponseFromJSON,
    DeviceStatusByDnspResponseToJSON,
    DnspControlIntervalsByDeviceResponseFromJSON,
    DnspControlIntervalsByDeviceResponseToJSON,
    DnspDeviceOptOutStatusResponseFromJSON,
    DnspDeviceOptOutStatusResponseToJSON,
    DnspGetDerEventResponseFromJSON,
    DnspGetDerEventResponseToJSON,
} from "../models/index";

export interface DnspGetControlIntervalsByDeviceRequest {
    dnsp: string;
    from: Date;
    to: Date;
    deviceId?: string;
}

export interface DnspGetDerEventRequest {
    derEventId: string;
}

export interface DnspGetDerEventsRequest {
    limit?: number;
    includeStatistics?: boolean;
    startingBefore?: Date;
    dnspTag?: string;
}

export interface DnspGetDeviceOptOutStatusRequest {
    deviceId: string;
}

/**
 *
 */
export class DnspDashboardHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get all control intervals for all devices the DNSP controls, for a specific time range (max 24 hrs), or for a specific device. Continuous intervals for the whole time range are returned. The default envelope\'s interval(s) are interpolated where none have been set (eg between envelopes). Opted-out devices will not be returned (unless called using the deviceId param, in which case the default envelope interval(s) are returned.)
     */
    async dnspGetControlIntervalsByDeviceRaw(
        requestParameters: DnspGetControlIntervalsByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DnspControlIntervalsByDeviceResponse>> {
        if (requestParameters["dnsp"] == null) {
            throw new runtime.RequiredError(
                "dnsp",
                'Required parameter "dnsp" was null or undefined when calling dnspGetControlIntervalsByDevice().',
            );
        }

        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling dnspGetControlIntervalsByDevice().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling dnspGetControlIntervalsByDevice().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = (
                requestParameters["from"] as any
            ).toISOString();
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = (
                requestParameters["to"] as any
            ).toISOString();
        }

        if (requestParameters["deviceId"] != null) {
            queryParameters["deviceId"] = requestParameters["deviceId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/dnsp/{dnsp}/intervalsbydevice`.replace(
                    `{${"dnsp"}}`,
                    encodeURIComponent(String(requestParameters["dnsp"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DnspControlIntervalsByDeviceResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get all control intervals for all devices the DNSP controls, for a specific time range (max 24 hrs), or for a specific device. Continuous intervals for the whole time range are returned. The default envelope\'s interval(s) are interpolated where none have been set (eg between envelopes). Opted-out devices will not be returned (unless called using the deviceId param, in which case the default envelope interval(s) are returned.)
     */
    async dnspGetControlIntervalsByDevice(
        requestParameters: DnspGetControlIntervalsByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DnspControlIntervalsByDeviceResponse> {
        const response = await this.dnspGetControlIntervalsByDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a DER Event, statistics, and the opt-out statuses of each device
     */
    async dnspGetDerEventRaw(
        requestParameters: DnspGetDerEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DnspGetDerEventResponse>> {
        if (requestParameters["derEventId"] == null) {
            throw new runtime.RequiredError(
                "derEventId",
                'Required parameter "derEventId" was null or undefined when calling dnspGetDerEvent().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/dnsp/derevent/{derEventId}`.replace(
                    `{${"derEventId"}}`,
                    encodeURIComponent(String(requestParameters["derEventId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DnspGetDerEventResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a DER Event, statistics, and the opt-out statuses of each device
     */
    async dnspGetDerEvent(
        requestParameters: DnspGetDerEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DnspGetDerEventResponse> {
        const response = await this.dnspGetDerEventRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Query DER events by DNSP and date, ordered by start date desc
     */
    async dnspGetDerEventsRaw(
        requestParameters: DnspGetDerEventsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DnspGetDerEventResponse>>> {
        const queryParameters: any = {};

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["includeStatistics"] != null) {
            queryParameters["includeStatistics"] =
                requestParameters["includeStatistics"];
        }

        if (requestParameters["startingBefore"] != null) {
            queryParameters["startingBefore"] = (
                requestParameters["startingBefore"] as any
            ).toISOString();
        }

        if (requestParameters["dnspTag"] != null) {
            queryParameters["dnspTag"] = requestParameters["dnspTag"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/dnsp/derevents`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DnspGetDerEventResponseFromJSON),
        );
    }

    /**
     * Query DER events by DNSP and date, ordered by start date desc
     */
    async dnspGetDerEvents(
        requestParameters: DnspGetDerEventsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DnspGetDerEventResponse>> {
        const response = await this.dnspGetDerEventsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a device\'s opt out time, and the last time it was seen online
     */
    async dnspGetDeviceOptOutStatusRaw(
        requestParameters: DnspGetDeviceOptOutStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DnspDeviceOptOutStatusResponse>> {
        if (requestParameters["deviceId"] == null) {
            throw new runtime.RequiredError(
                "deviceId",
                'Required parameter "deviceId" was null or undefined when calling dnspGetDeviceOptOutStatus().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/dnsp/device/{deviceId}/status`.replace(
                    `{${"deviceId"}}`,
                    encodeURIComponent(String(requestParameters["deviceId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DnspDeviceOptOutStatusResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a device\'s opt out time, and the last time it was seen online
     */
    async dnspGetDeviceOptOutStatus(
        requestParameters: DnspGetDeviceOptOutStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DnspDeviceOptOutStatusResponse> {
        const response = await this.dnspGetDeviceOptOutStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a count of device connectors by status by DNSP. Only connectors that belong to devices that belong to DNSPs that are part of JemenaProject are returned. If you are admin, the group JETCharge is also returned, containing all connectors in the system. Intended for the Jemena Project overview dashboard.
     */
    async getDeviceConnectorStatusByDNSPsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ConnectorStatusByDnspResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/dnsp/device-status-by-dnsps/connectors`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ConnectorStatusByDnspResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a count of device connectors by status by DNSP. Only connectors that belong to devices that belong to DNSPs that are part of JemenaProject are returned. If you are admin, the group JETCharge is also returned, containing all connectors in the system. Intended for the Jemena Project overview dashboard.
     */
    async getDeviceConnectorStatusByDNSPs(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ConnectorStatusByDnspResponse> {
        const response =
            await this.getDeviceConnectorStatusByDNSPsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a count of devices by status by DNSP. Only devices that belong to DNSPs that are part of JemenaProject are returned. If you are admin, the group JETCharge is also returned, containing all devices in the system. Intended for the Jemena Project overview dashboard.
     */
    async getDeviceStatusByDNSPsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceStatusByDnspResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/dnsp/device-status-by-dnsps`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceStatusByDnspResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a count of devices by status by DNSP. Only devices that belong to DNSPs that are part of JemenaProject are returned. If you are admin, the group JETCharge is also returned, containing all devices in the system. Intended for the Jemena Project overview dashboard.
     */
    async getDeviceStatusByDNSPs(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceStatusByDnspResponse> {
        const response = await this.getDeviceStatusByDNSPsRaw(initOverrides);
        return await response.value();
    }
}
